import { useMutation } from '@tanstack/react-query'
import { request } from 'Lib/axios'
import { useUserStore } from 'Stores/userStoreModuleFed'

export const postEmailToDev = async (accountId: number, domainId: number, email: string) => {
  return await request({
    method: 'POST',
    url: `/accounts/${accountId}/domains/${domainId}/codeemailtodev`,
    data: { email },
  })
}

export const useSendTrackingCodeToEmail = ({ domainId }: { domainId: number }) => {
  const { accountId } = useUserStore()
  return useMutation({
    mutationFn: (email: string) => postEmailToDev(accountId, domainId, email),
  })
}
